export default __webpack_public_path__ + "images/assets/dfac1595803e8fdf2ee137fcd1ca493e.svg";